import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API, { ensureCsrfToken } from '../services/api';
import { loginErrorMessage } from "../utils/loginError";
import brandLockup from "../assets/telemindra-lockup.png";
import "./LoginPage.css";

const LoginPage = ({ setIsAuthenticated }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            await ensureCsrfToken();
            const response = await API.post("/login/", {
                email,
                password,
            });
            localStorage.setItem("token", response.data.csrf_token);
            setIsAuthenticated(true);
            navigate("/");
        } catch (err) {
            setError(loginErrorMessage(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="login-container">
            <section className="login-brand-panel" aria-label="Telemindra Industrial">
                <img src={brandLockup} className="login-lockup" alt="Telemindra" />
                <div className="login-brand-copy">
                    <span className="login-product-chip">Industrial IoT</span>
                    <h1>Operational clarity, from signal to decision.</h1>
                    <p>
                        Monitor assets, analyse process history and control industrial
                        operations from one secure workspace.
                    </p>
                </div>
                <ul className="login-capabilities" aria-label="Platform capabilities">
                    <li><span aria-hidden="true" />Live telemetry</li>
                    <li><span aria-hidden="true" />Industrial analytics</li>
                    <li><span aria-hidden="true" />Role-based control</li>
                </ul>
                <p className="login-brand-footnote">Telemindra Industrial Operations Platform</p>
            </section>

            <main className="login-form-panel">
                <form className="login-form" onSubmit={handleLogin}>
                    <div className="login-form-heading">
                        <span>Secure workspace</span>
                        <h2>Welcome back</h2>
                        <p>Sign in with your authorised work account.</p>
                    </div>

                    <label htmlFor="login-email">Email address</label>
                    <input
                        id="login-email"
                        type="email"
                        placeholder="name@company.com"
                        autoComplete="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <label htmlFor="login-password">Password</label>
                    <input
                        id="login-password"
                        type="password"
                        placeholder="Enter your password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    {error && <p className="error-message" role="alert">{error}</p>}
                    <button type="submit" disabled={submitting}>
                        {submitting ? "Signing in…" : "Sign in"}
                    </button>
                    <p className="login-support">Access is managed by your organisation administrator.</p>
                </form>
            </main>
        </div>
    );
};

export default LoginPage;
